// import createHistory from 'history/createHashHistory';
// import { routerMiddleware } from 'react-router-redux';
import { Store } from 'redux';

import { StateStoreUtils } from '../../Shared/stores';
import redirectMiddleware from '../middleware/redirect';
import rootReducer from '../reducers/index';
import builderSaga from '../sagas/builder';

export let history: any = null;
let store;
export default function configureStore(initialState?: any): Store {
    // history = createHistory();

    let middleware: Array<any> = [
        // redirectMiddleware, //has to be before router because of the way it triggers actions
        // routerMiddleware(history),
    ];

    let sagaMiddleware: Array<any> = [builderSaga];
    if (!store) {
        store = StateStoreUtils.configureStore(initialState, rootReducer, sagaMiddleware, middleware);
    }
    return store;
}
